import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  headingId?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  icon,
  headingId,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div>
        <div className="flex items-center gap-2">
          {icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={icon}></i>
            </span>
          )}
          <h2 id={headingId} className="font-heading text-lg font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
        </div>
        {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line"></i></span>
        </Link>
      )}
    </div>
  );
}